import { Filter, type FilterIterable, type FilterIterableStrict, type FilterValues } from '@pkg/classes';

import { nftFiltersKeys, nftFiltersKeyToQueryKeyMap, nftFiltersMultipleValueSupport } from './data';
import { type NftFiltersKey, type NftFiltersQuery } from './types';

export function convertNftFiltersKeyToQueryKey(key: NftFiltersKey) {
    const convertedKey = nftFiltersKeyToQueryKeyMap[key];
    return convertedKey ?? key;
}

export function convertNftFiltersValueToQueryValue(key: NftFiltersKey, value: FilterValues) {
    if (value.length === 0) {
        return undefined;
    }

    const lastIndex = value.length - 1;
    return nftFiltersMultipleValueSupport.includes(key) ? value : value[lastIndex];
}

export function convertNftFiltersToServerQuery(filters: Filter) {
    const entries = [...filters.entries()];

    return entries.reduce<NftFiltersQuery>((collection, [key, value]) => {
        // TODO: Unsure how to avoid this typecast.
        const typedKey = key as NftFiltersKey;

        const mappedKey = convertNftFiltersKeyToQueryKey(typedKey);
        const mappedValue = convertNftFiltersValueToQueryValue(typedKey, value);

        return {
            ...collection,
            ...(mappedKey && mappedValue ? { [mappedKey]: mappedValue } : {}),
        };
    }, {});
}

export function convertSearchParamsToNftFilters(searchParams: URLSearchParams) {
    const entries = [...searchParams.entries()];
    const criteria: string[] = [...nftFiltersKeys];

    const iterable: FilterIterable = entries.reduce<FilterIterableStrict>((list, [key, value]) => {
        if (criteria.includes(key)) {
            list.push([key, value.split(',')]);
        }

        return list;
    }, []);

    return new Filter(iterable);
}

interface RemoveNftFiltersCriteria {
    searchParams: URLSearchParams;
    filters: Filter;
}

export function removeNftFiltersFromSearchParams({ searchParams, filters }: RemoveNftFiltersCriteria) {
    const entries = [...searchParams.entries()];
    const activeFiltersKeys = [...filters.keys()];
    const absentKeys = nftFiltersKeys.filter((key) => !activeFiltersKeys.includes(key));

    const revisedParams = entries.reduce<Record<string, string>>((list, [key, value]) => {
        // TODO: Try to avoid this typecast.
        const omitEntry = absentKeys.includes(key as NftFiltersKey);

        return {
            ...list,
            ...(omitEntry ? {} : { [key]: value }),
        };
    }, {});

    return new URLSearchParams(revisedParams);
}
